var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"tender",attrs:{"id":"main"}},[_c('ItemSearch',{attrs:{"parent":_vm.$data,"search":_vm.searchTenderItems,"printItemsCsv":_vm.printItemsCsv,"favorite":_vm.favorite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }